var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgEyeOff = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.275 7.275a2.435 2.435 0 0 1 3.446 0 2.435 2.435 0 0 1 0 3.446" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M3.867 6.369c-1.211 1.3-1.804 2.635-1.804 2.635S4.313 14.063 9 14.063c.795 0 2.01-.234 2.175-.387M4.795 5.5C5.87 4.628 7.269 3.938 9 3.938c4.313 0 6.938 5.066 6.938 5.066s-1.088 2.574-3.483 4.044M2.438 2.438l13.125 13.125" })] }))); };
export default SvgEyeOff;
